import { useState } from 'react';

const GestorAssignmentModal = ({ gestoresDisponibles, onAssign, onClose }) => {
    const [selectedGestorId, setSelectedGestorId] = useState('');
    const [motivo, setMotivo] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      if (!selectedGestorId) {
        success('Selecciona un gestor');
        return;
      }
      onAssign(selectedGestorId, motivo);
    };
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-2xl w-full mx-4">
          <div className="p-6 border-b border-gray-200">
            <h3 className="text-xl font-bold text-gray-900">Asignar Gestor</h3>
          </div>
  
          <form onSubmit={handleSubmit} className="p-6">
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Seleccionar Gestor *
              </label>
              <select
                value={selectedGestorId}
                onChange={(e) => setSelectedGestorId(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              >
                <option value="">Selecciona un gestor...</option>
                {gestoresDisponibles.map((gestor) => (
                  <option key={gestor.id} value={gestor.id}>
                    {gestor.name} - {gestor.status} ({gestor.current_assignments}/{gestor.max_concurrent})
                  </option>
                ))}
              </select>
            </div>
  
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Motivo de Asignación (Opcional)
              </label>
              <textarea
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent h-20"
                placeholder="Especialización requerida, carga de trabajo, etc."
              />
            </div>
  
            <div className="flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-3 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Asignar Gestor
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  };

export default GestorAssignmentModal;